<template>
    <div id="page">
        <GlobalLoader />
        <div class="container">
            <div id="content">
                <div v-if="$route.path !== '/login'" class="row">
                    
                    <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-12">
                        <div class="main-content">
                            <router-view></router-view>
                        </div>
                    </div>
                    <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
                        <Sidebar />
                    </div>
                </div>
                <div v-else class="row">
                    <div class="col-md-12">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Sidebar from './commons/Sidebar/Sidebar';
import GlobalLoader from './commons/GlobalLoader/GlobalLoader';
import DibbleJS from "./dibble";
export default {
    name: 'App',
    components: {
        Sidebar,
        GlobalLoader
    },
    mounted() {
        if (this.$route.path !== '/login') {
            DibbleJS.checkIsExpiredSession();
        }
    }
}
</script>

<style lang="css">
    @import '~bootstrap/dist/css/bootstrap.css';
    @import '~bootstrap-vue/dist/bootstrap-vue.css';
    @import "assets/css/bootstrap-select.min.css";
    @import "assets/css/main.css";
    @import "assets/css/responsive.css";
    @import "assets/css/font.css";
    @import "assets/css/predefined.css";
    @import "assets/css/tailStyle.css";
   /* #page {
        direction: rtl;
    }*/
</style>
